import styled from 'styled-components';
import colors from '../../assets/styles/colors';
import ReactTooltip from 'react-tooltip';

export const CdtListByColContainer = styled.div`
  transition: ease-in-out .2s;

  &.fade {
    opacity: 0;
  }

  &.fade.show {
    opacity: 1;
  }
`;

export const CdtListByGridContainer = styled.div`
  display: flex;
  align-items: space-between;
  flex-direction: column;
`;

export const CdtListByGridHeadTitle = styled.div`
  padding: 22px 0;
  display: flex;
  
  p {
    font-size: 12px;
  }
`;

export const CdtListByGridHeadTitleSpan = styled.span`
  font-size: 12px;
  color: ${colors.textSecondary};
  margin-left: 5px;
`;

export const CdtListByGridContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 24px;
  transition: ease-in-out .2s;
`;

export const CdtListByGridShowMore = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const CdtListByGridShowMoreButton = styled.button`
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.textSecondary};
  font-size: 14px;
  line-height: 17px;
  font-weight: bold;
  color: ${colors.textPrimary};
  padding: 6px 26px;
  display: flex;
  align-items: center;
  margin: 30px 0 14px 0;
  transition: .2s;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
    -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
  }

  svg {
    margin-right: 5px;
  }
`;

export const TooltipTitle = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
`;

export const TooltipContent = styled.div`
font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.03em;
`;

export const Tooltip = styled(ReactTooltip).attrs({
  className: "custom-tooltip",
})`
  &.custom-tooltip {
    width: 300px !important;
    padding: 13px !important;
    font-family: Montserrat !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 22px !important;
    letter-spacing: 0.03em !important;
    opacity: 1 !important;
    background-color: rgb(187, 215, 212);
  }
`;

export const InfoCircleImage = styled.img`
  margin-bottom:-3px;
  margin-left: 3px;
`;  

